import { createReducer, on } from '@ngrx/store';

import { DefaultColorEnum } from '../../enums/default-color';
import { ThemeColors } from '../../typings/theme';
import * as fromPersistedStateActions from '../actions/persisted-state.actions';
import * as fromSettingActions from '../actions/setting.actions';
import * as fromWhiteLabelingActions from '../actions/white-labeling.actions';

export const whiteLabelingFeatureKey = 'whiteLabeling';

export interface State {
  colors: ThemeColors;
  logoUrl: string;
}

export const initialState: State = {
  colors: {
    danger: DefaultColorEnum.danger,
    dark: DefaultColorEnum.dark,
    light: DefaultColorEnum.light,
    medium: DefaultColorEnum.medium,
    primary: DefaultColorEnum.primary,
    secondary: DefaultColorEnum.secondary,
    success: DefaultColorEnum.success,
    tertiary: DefaultColorEnum.secondary,
    warning: DefaultColorEnum.warn
  },
  logoUrl: '/assets/logo.svg'
};

export const reducer = createReducer(
  initialState,
  on(
    fromSettingActions.updateReferralCodeSuccess,
    fromSettingActions.loadSettingsSuccess,
    fromSettingActions.refreshReferralCodeSuccess,
    fromPersistedStateActions.migratePersistedOldStateReferralCodeSuccess,
    (state, { payload }) => ({
      ...state,
      colors: {
        ...state.colors,
        ...{
          danger: payload.data.organization.whiteLabeling.danger,
          dark: payload.data.organization.whiteLabeling.dark,
          // light: action.data.organization.whiteLabeling.light,
          light: DefaultColorEnum.light,
          primary: payload.data.organization.whiteLabeling.primary,
          secondary: payload.data.organization.whiteLabeling.secondary,
          success: payload.data.organization.whiteLabeling.success,
          tertiary: payload.data.organization.whiteLabeling.secondary,
          warning: payload.data.organization.whiteLabeling.warn
        }
      },
      logoUrl: payload.data.organization.logo ?? '/assets/logo.svg'
    })
  ),
  on(fromWhiteLabelingActions.updateMainColors, (state, { payload: { primary, secondary } }) => ({
    ...state,
    colors: {
      ...state.colors,
      ...{
        primary,
        secondary
      }
    }
  })),
  on(fromPersistedStateActions.loadPersistedStateFailure, fromPersistedStateActions.persistedStateReset, () => ({
    ...initialState
  })),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[whiteLabelingFeatureKey]
  }))
);
